import { Injectable } from '@angular/core';
import { EnvironmentsService } from 'app/services/enviornment.service';


@Injectable()

export class AuthProviderService {

  private apiUrl = '';
  private apiLogoutUrl = '';
  constructor(private envService: EnvironmentsService) {
    this.apiUrl = this.envService.config.api;
    this.apiLogoutUrl = this.envService.config.apiLogoutUrl;
  }
  public getApiUrl() {
    return this.apiUrl;
  }

  public getApiLogoutUrl() {
    return this.apiLogoutUrl;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth.provider.service.ts